import type { SentryServiceInterface } from './interfaces/sentry.service.interface';
import { SentryService } from './sentry';
declare module '#app' {
    interface NuxtApp {
        $sentry: SentryServiceInterface;
    }
}

export default defineNuxtPlugin({
    dependsOn: ['platform', 'webos-plugin'],
    setup: (nuxtApp) => {
        const sentryService = new SentryService();

        // Register the Sentry service globally
        nuxtApp.provide('sentry', sentryService);
    }
});
